import { ReduxService } from 'dashboard-services/services';

import { settingsCurvesActions } from 'actions/curves';
import { LocalStorageUtils } from 'utils';

export const getSettingsInitialState = () => ReduxService.updateObject(settingsCurvesActions.defaultState, LocalStorageUtils.getCurveDefaultSettings())

export default (state = getSettingsInitialState(), action) => {
  switch (action.type) {
    case settingsCurvesActions.ON_CHANGE: {
      if(action.name === "formulaExpressions") {
        return ReduxService.updateObject(state, { formulaExpressions: action.value })
      }
      const formulaExpressions = { ...(state.formulaExpressions || {}) }
      if(formulaExpressions[action.name]) {
        delete formulaExpressions[action.name]
      }
      return ReduxService.updateObject(state, { [action.name]: action.value, formulaExpressions })
    }
    case settingsCurvesActions.CLEAR: 
      return getSettingsInitialState();
    default:
      return state;
  }
}
